import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,isFunction } from '../../../../utils/utils';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import JourneyTripCreateViewLRCard from './JourneyTripCreateViewLRCard';
import JourneyTripCreateViewPODCard from './JourneyTripCreateViewPODCard';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    backgroundColor:'#fff',
    borderRadius:4,
    marginTop:8
  },
  topSection:{
    display:'flex',
    width:'100%',
    justifyContent:'space-between',
    alignItems:'center',
  },
  addLoadDiv:{
    backgroundColor:'#fafafa',
    paddingRight:16,
    paddingLeft:16,
    padding:12,
  },
  addLoadButton:{
    marginRight:16,
    width: '100%',
    padding:'4px 16px',
    backgroundColor: '#fff',
    textTransform: 'capitalize',
    color: '#00875a',
    fontWeight: 600,
    borderRadius: 8,
    fontSize:14,
    border: 'solid 1px #00875a',
    '&:hover': {
      backgroundColor: '#fff'
    }
  }
}));
const AntTabs = withStyles({
  root: {
    backgroundColor:'#fafafa',
    borderRadius:4,
    width:'100%'
    //borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    display:'none'
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    backgroundColor:'#fafafa',
    minWidth: 137,
    borderRadius:4,
    color: '#0b1323',
    fontWeight:600,
    fontSize:16,
    boxShadow:'0 4px 4px 0 rgba(0, 0, 0, 0.25)',
    padding:16,
    opacity:'unset',
    //marginRight: theme.spacing(4),
    '&:first-of-type': {
      borderBottomLeftRadius:0,
      borderTopLeftRadius:0,
    },
    '&:last-of-type': {
      borderBottomRightRadius:0,
      borderTopRightRadius:0,
    },
    '&:hover': {
      color: '#0b1323',
      opacity: 1,
    },
    '&$selected': {
      color: '#0b1323',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor:'#fff',
      boxShadow:'none',
      fontWeight:600,
      borderBottomLeftRadius:0,
      borderBottomRightRadius:0,
    },
    '&:focus': {
      color: '#0b1323',
    },
  },
  wrapper: {
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
const JourneyTripsPODBiltyTabs = (props) => {
  const {journey,updateJourney,onTripTabChange,activeTab} = props;
  const classes = useStyles();
  let history = useHistory();
  const [tab, setTab] = React.useState(activeTab);

  const handleTabChange = (event, newValue) => {
    if(onTripTabChange && isFunction(onTripTabChange)){
      onTripTabChange(newValue);
    }
  };
  return (
    <>
      <div className={classes.card}>
        <div className={classes.topSection}>
          <AntTabs value={activeTab} onChange={handleTabChange} aria-label="Trips tab">
            {journey && journey.trips && journey.trips.map((trip,index)=>{
                return <AntTab label={trip && trip.customer && trip.customer.customerName? trip.customer.customerName:''} {...a11yProps(index)} />
            })}
          </AntTabs>
        </div>
        {journey && journey.trips && journey.trips.map((trip,index)=>{
              return <TabPanel value={activeTab} index={index}>
                  <Grid container spacing={1}>
                    <JourneyTripCreateViewLRCard selectedTrip={trip} journey={journey} updateJourney={updateJourney}/>
                    <JourneyTripCreateViewPODCard selectedTrip={trip} journey={journey} updateJourney={updateJourney}/>
                  </Grid>
            </TabPanel>
        })}
      </div>
    </>
  );
}
export default JourneyTripsPODBiltyTabs;